<div class="iri_lock">
    <div class="icon_lock">
        <img src="../../../../assets/icons/IconLock.svg" />
    </div>
    <div class="icon_premium_title">
        <img src="../../../../assets/icons/IconPremium.svg" />
        <span>ISRI Report</span>
    </div>
    <p>A comprehensive ethical and sustainability screening of the company which specifies how well a stock aligns with
        ISRI values through a Shariah-compliant lens!</p>



    <button class="btn shadow-none rounded-3 text-white py-2 px-4 gradient-btn"
        *ngIf="userRole === 'FREEMIUM' || userRole === 'ANONYMOUS'" (click)="accessControlService.accessDenied()">
        <!-- Upgrade & Unlock! -->
        <img src="../../../../assets/icons/lock-white.svg" width="16" height="16" alt="lock image" class="img-fluid">
        <span>Unlock</span>
    </button>


    <a href="#" class="link_view_sample">View Sample Musaffa SRI Report</a>
</div>